export default function omit(obj: any, blacklist: string[]): any {
  const insensitiveBlacklist = blacklist.map(prop => prop.toLowerCase())
  return Object.keys(obj).reduce((result: any, prop: string) => {
    if (!insensitiveBlacklist.includes(prop.toLowerCase())) {
      result[prop] = obj[prop]
    }
    return result
  }, {})
}
